
import dotenv from 'dotenv';
dotenv.config();

export const GenQRCode = (qrcode_string: string) => {
        const URL_QR = process.env.REACT_APP_URL_GEN_QRCODE_TRANSFER ?? '';

        return `${URL_QR}?data=${qrcode_string}`;
};